interface EmailSpinnerProps {
  size?: number;
  className?: string;
  off?: boolean;
}

export default function EmailSpinner({
  size = 48,
  className = "",
  off = false,
}: EmailSpinnerProps) {
  const colorClass = off
    ? "text-[var(--text-muted)] opacity-35"
    : className.includes("text-")
    ? ""
    : "text-accent";

  return (
    <div
      className={`inline-flex items-center justify-center transition-colors duration-200 ${colorClass} ${className}`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="neonGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="currentColor" stopOpacity="0.2" />
            <stop offset="50%" stopColor="currentColor" stopOpacity="1">
              {!off && <animate attributeName="offset" values="0;0.5;1" dur="1.8s" repeatCount="indefinite" />}
            </stop>
            <stop offset="100%" stopColor="currentColor" stopOpacity="0.2" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="1.8" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Envelope Base Rectangle */}
        <rect
          x="4"
          y="12"
          width="40"
          height="28"
          rx="4"
          stroke={off ? "currentColor" : "url(#neonGrad)"}
          strokeWidth="2.5"
          fill="none"
          filter={off ? undefined : "url(#glow)"}
        >
          {!off && <animate attributeName="stroke-opacity" values="0.3;1;0.3" dur="1.8s" repeatCount="indefinite" />}
        </rect>

        {/* Envelope Top V Flap */}
        <path
          d="M4 14.5 L24 28 L44 14.5"
          stroke={off ? "currentColor" : "url(#neonGrad)"}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          filter={off ? undefined : "url(#glow)"}
        >
          {!off && (
            <animate
              attributeName="stroke-opacity"
              values="0.3;1;0.3"
              dur="1.8s"
              repeatCount="indefinite"
              begin="0.3s"
            />
          )}
        </path>

        {/* Bottom diagonal corner lines */}
        <path
          d="M5 38.5 L17.5 26"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity={off ? 0.4 : 0.35}
        >
          {!off && (
            <animate
              attributeName="opacity"
              values="0.15;0.6;0.15"
              dur="1.8s"
              repeatCount="indefinite"
              begin="0.6s"
            />
          )}
        </path>
        <path
          d="M43 38.5 L30.5 26"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity={off ? 0.4 : 0.35}
        >
          {!off && (
            <animate
              attributeName="opacity"
              values="0.15;0.6;0.15"
              dur="1.8s"
              repeatCount="indefinite"
              begin="0.6s"
            />
          )}
        </path>
      </svg>
    </div>
  );
}
